var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCoinTail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddn_3379_7985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0264 5.77441C19.2991 6.21847 19.5375 6.68552 19.7393 7.17188L19.3662 7.32715C19.557 7.78726 19.7131 8.26583 19.8311 8.75879L20.2227 8.66406C20.3431 9.1674 20.4247 9.68514 20.4658 10.2148L20.0654 10.2461C20.0847 10.4948 20.0947 10.7462 20.0947 11C20.0947 11.2538 20.0847 11.5052 20.0654 11.7539L20.4658 11.7842C20.4247 12.3139 20.3431 12.8316 20.2227 13.335L19.8311 13.2412C19.7131 13.7342 19.557 14.2127 19.3662 14.6729L19.7393 14.8271C19.5376 15.3135 19.2991 15.7805 19.0264 16.2246L18.6816 16.0137C18.4181 16.4428 18.1216 16.8494 17.7959 17.2305L18.1025 17.4922C17.7619 17.8907 17.3907 18.2619 16.9922 18.6025L16.7305 18.2959C16.3494 18.6216 15.9428 18.9181 15.5137 19.1816L15.7246 19.5264C15.2805 19.7991 14.8135 20.0376 14.3271 20.2393L14.1729 19.8662C13.7127 20.057 13.2342 20.2131 12.7412 20.3311L12.835 20.7227C12.3316 20.8431 11.8139 20.9247 11.2842 20.9658L11.2539 20.5654C11.0052 20.5847 10.7538 20.5947 10.5 20.5947C10.2462 20.5947 9.99477 20.5847 9.74609 20.5654L9.71484 20.9658C9.18514 20.9247 8.6674 20.8431 8.16406 20.7227L8.25879 20.3311C7.76583 20.2131 7.28726 20.057 6.82715 19.8662L6.67188 20.2393C6.18552 20.0375 5.71847 19.7991 5.27441 19.5264L5.48633 19.1816C5.05725 18.9181 4.65057 18.6216 4.26953 18.2959L4.00684 18.6025C3.60834 18.2619 3.2371 17.8907 2.89648 17.4922L3.2041 17.2305C2.87838 16.8494 2.58188 16.4428 2.31836 16.0137L1.97266 16.2246C1.7 15.7805 1.46144 15.3135 1.25977 14.8271L1.63379 14.6729C1.44299 14.2127 1.2869 13.7342 1.16895 13.2412L0.776367 13.335C0.655947 12.8317 0.574301 12.3138 0.533203 11.7842L0.93457 11.7539C0.915252 11.5052 0.905273 11.2538 0.905273 11C0.905273 10.7462 0.915252 10.4948 0.93457 10.2461L0.533203 10.2148C0.574351 9.68519 0.655901 9.16736 0.776367 8.66406L1.16895 8.75879C1.2869 8.26583 1.44299 7.78726 1.63379 7.32715L1.25977 7.17188C1.45535 6.7003 1.68483 6.24637 1.94727 5.81445L1.97266 5.77441L2.31836 5.98633C2.58188 5.55725 2.87838 5.15057 3.2041 4.76953L2.89648 4.50684C3.23711 4.10834 3.60834 3.73711 4.00684 3.39648L4.26953 3.7041C4.65057 3.37838 5.05725 3.08188 5.48633 2.81836L5.27441 2.47266C5.71845 2.19997 6.18555 1.96147 6.67188 1.75977L6.82715 2.13379C7.28726 1.94299 7.76583 1.7869 8.25879 1.66895L8.16406 1.27637C8.66736 1.1559 9.18519 1.07435 9.71484 1.0332L9.74609 1.43457C9.99477 1.41525 10.2462 1.40527 10.5 1.40527C10.7538 1.40527 11.0052 1.41525 11.2539 1.43457L11.2842 1.0332C11.8138 1.0743 12.3317 1.15595 12.835 1.27637L12.7412 1.66895C13.2342 1.7869 13.7127 1.94299 14.1729 2.13379L14.3271 1.75977C14.8135 1.96144 15.2805 2.2 15.7246 2.47266L15.5137 2.81836C15.9428 3.08188 16.3494 3.37838 16.7305 3.7041L16.9922 3.39648C17.3907 3.7371 17.7619 4.10834 18.1025 4.50684L17.7959 4.76953C18.1216 5.15057 18.4181 5.55725 18.6816 5.98633L19.0264 5.77441Z",
    stroke: "#229EFF",
    strokeWidth: 0.811359,
    strokeDasharray: "1.62 1.62",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iin_3379_7985)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.4989,
    cy: 10.9989,
    r: 9.18864,
    transform: "rotate(180 10.4989 10.9989)",
    fill: "#BDE2FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_in_3379_7985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.70086 12.5139H5.83203V9.81366H10.6751V12.5139H15.1679V9.47656",
    stroke: "#229EFF",
    strokeWidth: 0.671664
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddn_3379_7985",
    x: 0.101082,
    y: 0.864773,
    width: 20.7573,
    height: 20.7573,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.0540906,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3379_7985"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.020284,
    dy: 0.243408
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.162272
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3379_7985"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.0540906,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3379_7985"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.020284,
    dy: 0.0811359
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.040568
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3379_7985",
    result: "effect2_dropShadow_3379_7985"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "49.29998779296875 49.29998779296875",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 2402
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.08)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_3379_7985"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  })), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "effect3_noise_3379_7985",
    in2: "effect2_dropShadow_3379_7985",
    result: "effect3_noise_3379_7985"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iin_3379_7985",
    x: 1.30859,
    y: 1.65023,
    width: 18.4398,
    height: 18.7807,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0608519,
    dy: 0.243408
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.243408
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3379_7985"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.162272
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.243408
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3379_7985",
    result: "effect2_innerShadow_3379_7985"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "49.29998779296875 49.29998779296875",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect2_innerShadow_3379_7985",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(225, 250, 250, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_3379_7985"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect2_innerShadow_3379_7985"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_in_3379_7985",
    x: 5.49609,
    y: 9.47656,
    width: 10.0078,
    height: 3.41557,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.040568
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0882353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3379_7985"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "49.29998779296875 49.29998779296875",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_innerShadow_3379_7985",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(179, 40, 33, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_3379_7985"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_innerShadow_3379_7985"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCoinTail);
export default __webpack_public_path__ + "static/media/blue-coin-tail.e82b3852862bf39ec09fbde743ebe7b0.svg";
export { ForwardRef as ReactComponent };